import React from 'react';
import { FormikTextArea } from 'components/UiKit/FormikFields';

// grow-ui drew this as eight 16px rows plus its padding and border.
const NOTES_HEIGHT = '146px';

function NotesField() {
  return (
    <div className="my-4 w-full">
      <div className="block">
        <div className="w-full">
          <FormikTextArea
            id="notes-textarea"
            name="notes"
            style={{ height: NOTES_HEIGHT }}
          />
        </div>
      </div>
    </div>
  );
}

export default NotesField;
